import * as React from "react";
import { Context } from "./_context";
export const CoinsIcon = ({ size = 24, variant = "inherit", ...rest }) => {
  const { variants } = React.useContext(Context);
  const color = variants[variant] || "#F0F";
  const props = { "aria-hidden": true, style: { color }, ...rest };
  const iconset = {};
  iconset[24] = /* @__PURE__ */ React.createElement("svg", { width: "1.5rem", height: "1.5rem", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "m22.332 17.945-1.664 1.11-6-9 1.664-1.11 6 9ZM13.5 19h-11v-2h11v2Zm1-4h-11v-2h11v2Zm-2-4h-11V9h11v2Zm3-4h-11V5h11v2Z", fill: "currentColor" }));
  return iconset[size];
};
CoinsIcon.iconId = "wTm6IN";
